<template>
  <v-container 
    v-if="!$apollo.loading"
    fill-height
    container--fluid
    grid-list-xl
  >
    <v-layout
      wrap
    >
      <v-flex
        xs12
      >
        <trader-view 
          v-if="$route.query.p"
          :connection-stats="connectionStats" 
        />
        <investor-view 
          v-if="$route.query.a"
          :connection-stats="connectionStats" 
        />
      </v-flex>
      <v-flex
        xs12
      >
        <v-tabs
          :value="tab"
        >
          <v-tab
            v-for="(n,i) in [$t('accounts.balanceHistory')]"
            :key="i"
            @click="changeTab(i)"
          >
            {{ n }}
          </v-tab>
        </v-tabs>
        <v-card class="details-card">
          <v-flex 
            v-show="tab == 0"
            xs12
            md12
            data
          > 
            <balance-history 
              :min-date="connectionStats.connection_start"
              :max-date="connectionStats.connection_end"
              :period-id="connectionStats.id"
              :base-currency="connectionStats.project.base_currency"
            />
          </v-flex>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

const CONNECTION_STATS_QUERY = require('@/graphql/queries/ConnectionStats.gql');
import TraderView from '@/views/Connections/partial/TraderView.vue'
import InvestorView from '@/views/Connections/partial/InvestorView.vue'
import BalanceHistory from '@/views/Connections/partial/BalanceHistory.vue'

export default {
  name: 'ConnectionView',
  components: {
    TraderView,
    InvestorView,
    BalanceHistory
  },
  data: () => ({
    tab: 0,
    loading: false,
  }),
  methods: {
    changeTab (i) {
      this.tab = i
    },
  },
  apollo: {
    connectionStats: {
      query: CONNECTION_STATS_QUERY,
      variables() {
        let params = {
          period_id: this.$route.params.id,
        }
        if (this.$route.query.p) {
          params.project_id = this.$route.query.p
        }
        if (this.$route.query.a) {
          params.account_id = this.$route.query.a
        }
        return params
      },
    }
  },
}
</script>



<style lang="scss" >
  
</style>
